import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

const formatNumber = value => (value || value === 0 ? Number(value).toLocaleString('en-US') : 0);

const freshnessLabel = (asOf) => {
  if (!asOf) return 'live';
  const parsed = moment(Number(asOf) || asOf);
  return parsed.isValid() ? `updated ${parsed.fromNow()}` : 'live';
};

const sortArrow = (sorting, field) => {
  if (sorting[0] !== field) return '';
  return sorting[1] === 1 ? ' ▲' : ' ▼';
};

const LoyaltyRankingTable = ({
  items, page, pageSize, hasMore, asOf, sorting, onSort, onRowClick, onPrevPage, onNextPage,
}) => {
  const from = page * pageSize;
  const currentPage = page + 1;

  return (
    <>
      <div className="lb-head">
        <span>Rank</span>
        <span>Fan</span>
        <span
          style={{ textAlign: 'right', cursor: 'pointer' }}
          onClick={() => onSort('achievementsCount')}
        >
          Ach
          {sortArrow(sorting, 'achievementsCount')}
        </span>
        <span
          style={{ textAlign: 'right', cursor: 'pointer' }}
          onClick={() => onSort('prizesCount')}
        >
          Prize
          {sortArrow(sorting, 'prizesCount')}
        </span>
        <span
          style={{ textAlign: 'right', cursor: 'pointer' }}
          onClick={() => onSort('totalPoints')}
        >
          Points
          {sortArrow(sorting, 'totalPoints')}
        </span>
      </div>

      {items.map((item, index) => {
        const rank = from + index + 1;
        const {
          email, name, achievementsCount, prizesCount, prizesClaimedCount, totalPoints,
        } = item;

        return (
          <div
            key={email}
            className="lb-row"
            onClick={() => onRowClick(email, rank)}
            style={{ cursor: 'pointer' }}
          >
            <span className={`rank${rank <= 3 ? ' top' : ''}`}>{String(rank).padStart(2, '0')}</span>
            <div className="who">
              <div className="em">{email}</div>
              <div className="nm">{name}</div>
            </div>
            <span className="count">{formatNumber(achievementsCount)}</span>
            <span className="count">
              {formatNumber(prizesClaimedCount)}
              /
              {formatNumber(prizesCount)}
            </span>
            <span className={`pts${rank === 1 ? ' lead' : ''}`}>{formatNumber(totalPoints)}</span>
          </div>
        );
      })}

      <div className="pager">
        <span>
          page
          {' '}
          {currentPage}
          {' · '}
          {freshnessLabel(asOf)}
        </span>
        <span>
          <button type="button" className="pg" disabled={page <= 0} onClick={onPrevPage}>&lsaquo; Prev</button>
          &nbsp;
          <button type="button" className="pg" disabled={!hasMore} onClick={onNextPage}>Next &rsaquo;</button>
        </span>
      </div>
    </>
  );
};

LoyaltyRankingTable.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({
    email: PropTypes.string,
    name: PropTypes.string,
    totalPoints: PropTypes.number,
    achievementsCount: PropTypes.number,
    prizesCount: PropTypes.number,
    prizesClaimedCount: PropTypes.number,
    lastActivityAt: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  })).isRequired,
  page: PropTypes.number.isRequired,
  pageSize: PropTypes.number.isRequired,
  hasMore: PropTypes.bool.isRequired,
  asOf: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  sorting: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])).isRequired,
  onSort: PropTypes.func.isRequired,
  onRowClick: PropTypes.func.isRequired,
  onPrevPage: PropTypes.func.isRequired,
  onNextPage: PropTypes.func.isRequired,
};

LoyaltyRankingTable.defaultProps = {
  asOf: null,
};

export default LoyaltyRankingTable;
